// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type MaterialtransportPage } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheMaterialtransporteAbtransportQuery = {
  search?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSucheMaterialtransporteAbtransport(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string,
  query: SucheMaterialtransporteAbtransportQuery
) => Promise<MaterialtransportPage> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, fuhrparkeintragId, query = {}) =>
      (await getAPI()).materialtransporte.sucheMaterialtransporteAbtransport({
        taetigkeitsberichtId,
        fuhrparkeintragId,
        ...query,
      }),
    [getAPI]
  );
}
